module.exports = __webpack_public_path__ + "static/media/Screenshot1024page42.9956f2b5.jpg";